import '../../assets/styles/auth.scss'
import '../../assets/styles/pages.scss'
import laptop from '../../assets/images/pages/laptop.jpg'
import { Link, useLocation, useMatch, useNavigate, useParams } from 'react-router-dom'
import { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react'
import DownloadFileModal from '../../components/common/download-file-modal'
import { GlobalContext, handleError } from '../../context/Provider'
import henceforthApi, { CURRENCY_SYMBOL } from '../../utils/henceforthApi'
import PaginationLayout from '../../components/common/PaginationLayout'
import Spinner from '../../components/common/spinner'
import moment from 'moment'
import BreadCrumb from '../../components/common/BreadCrumb'
import { numberWithCommas } from '../../utils/validations'
import { ProductList } from './productInterface'
import { toast } from 'react-toastify'
import AllFilter from '../../components/common/AllFilter'
import COPY from "../../../src/assets/images/copy.png"
import { initLangData } from '../../utils/henceforthLanguage'
import SignedImage from '../../components/common/SignedImage'
// import { Link, useLocation, useMatch, useParams, useNavigate } from 'react-router-dom'

const StoreProducts = () => {
    // const match: any = useMatch('/:storeId/products/:page');

    // const storeId = match?.params.storeId;
    // const page = match?.params.page;
    // const { storeId, page } = useParams();
    const { authState, loading, setLoading, authDispatch, language_data } = useContext(GlobalContext)
    let breadCrumbPath = [
        { name: `${language_data?.[authState.lang]?.common_home}`, url: `/`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_list}`, url: ``, active: 'not-allowed' }
    ]
    let Limit = 10;
    // const location = useLocation();
    // const newParam = new URLSearchParams(location.search);
    const { storeId, page } = useParams();
    const location = useLocation();
    const newParam = new URLSearchParams(location.search);

    const router = useNavigate();

    const [sortField, setSortField] = useState(newParam.get("sort_by") || "");
    const [sortOrder, setSortOrder] = useState(newParam.get("sort_order") || "asc");

    const onSort = (field: string) => {
        const newOrder = sortField === field && sortOrder === "asc" ? "desc" : "asc";

        setSortField(field);
        setSortOrder(newOrder);

        const params = new URLSearchParams(location.search);
        params.set("sort_by", field);
        params.set("sort_order", newOrder);

        const currentPage = page || "1";
        router(`/store/${storeId}/products/${page}?${params.toString()}`);
    };

    const SortIcon = ({ field }: { field: string }) => (
        <span
            className="ms-1"
            style={{ cursor: "pointer", display: "inline-flex", gap: "4px", verticalAlign: "middle" }}
            onClick={() => onSort(field)}
        >
            <i className="fa fa-arrow-up" style={{ fontSize: "13px", color: sortField === field && sortOrder === "asc" ? "#29ABE2" : "#b0b8c1" }} />
            <i className="fa fa-arrow-down" style={{ fontSize: "13px", color: sortField === field && sortOrder === "desc" ? "#e03131" : "#b0b8c1" }} />
        </span>
    );

    const [productList, setProductList] = useState({
        totalCount: 0,
        listing: [],
    } as ProductList)

    const [stockModal, setStockModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<any>(null);
    const [quantity, setQuantity] = useState('');

    // ---------- NEW STATE FOR BULK UPLOAD ----------
    const [bulkModal, setBulkModal] = useState(false);
    const [bulkFile, setBulkFile] = useState<File | null>(null);
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const exportData = async (startDate: number, endDate: number) => {
        try {
            const apiRes = await henceforthApi.Product.export(startDate, endDate)
            const data = apiRes.data.data
            const rows = [
                [
                    "Sr.",
                    "Product Id",
                    "Category Level 1",
                    "Category level 2",
                    "Brand",
                    "Product Name",
                    "Product Price",
                    "Quantity",
                ],
            ];

            if (Array.isArray(data)) {
                data.map((res: any, index: any) => {
                    return rows.push([
                        index,
                        res?.prodct_id,
                        res?.category_id?.name,
                        res?.subcategory_id?.name,
                        res?.brand_id?.name,
                        res?.name,
                        res?.price,
                        res?.quantity,
                    ])
                })
            }
            console.log(rows);
            let csvContent =
                "data:text/csv;charset=utf-8," +
                rows.map((e) => e.join(",")).join("\n");
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `product_${moment().valueOf()}.csv`);
            document.body.appendChild(link); // Required for FF
            link.click(); // This will download the data file named "my_data.csv".
            let closeModal = document.getElementById("closeModal");
            if (closeModal) {
                closeModal.click();
            }
        } catch (error) {
            handleError(error, 'active', authDispatch);
        }

    }
    const copyText = (id: string) => {
        if (id) {
            navigator?.clipboard?.writeText(id)
            toast.success(`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_id} ${language_data?.[authState.lang]?.common_copy} ${language_data?.[authState.lang]?.common_successfull}`)
        }
    }
    const productListing = async () => {
        const currentPage = Number(page || 1);

        setLoading(true)
        try {
            let res = (await henceforthApi.Product.getStoreProductList(
                storeId as any,
                '',
                Number(currentPage) - 1,
                Limit,
                newParam.toString()
            )).data
            setProductList({
                ...productList,
                totalCount: res.total_count,
                listing: res.data,
            })

        } catch (err: any) {
            // console.log("err", err.response.body.error_description);
            if (newParam.has('product_id')) {
                toast.warn(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_search} ${language_data?.[authState.lang]?.common_proper} ${language_data?.[authState.lang]?.common_id}`)
                setProductList({
                    ...productList,
                    listing: [],
                })
            }
            handleError(err, '', authDispatch);
        } finally {
            setLoading(false)
        }
    }

    // useEffect(() => {
    //     productListing();

    // }, [page, newParam.get("search"), newParam.get("product_id"), newParam.get("min_price"), newParam.get("max_price")])
    useEffect(() => {
        productListing();
    }, [page, location.search])

    const handleManageStock = (product: any) => {
        setSelectedProduct(product);
        setQuantity('');
        setStockModal(true);
    };

    const submitStock = async () => {
        try {
            if (!quantity || Number(quantity) < 0) {
                return toast.error("Please enter valid quantity");
            }

            setLoading(true);

            await henceforthApi.Store.manageProductStock(
                selectedProduct?._id,
                {
                    quantity: Number(quantity)
                }
            );

            toast.success("Stock updated successfully");

            setStockModal(false);
            productListing();

        } catch (error: any) {
            handleError(error, '', authDispatch);
        } finally {
            setLoading(false);
        }
    };

    // ---------- NEW FUNCTIONS FOR BULK UPLOAD ----------
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setBulkFile(e.target.files[0]);
        }
    };

    const handleBulkUpload = async () => {
        if (!bulkFile) {
            toast.error("Please select a CSV file");
            return;
        }

        // Validate file type
        if (!bulkFile.name.endsWith('.csv') && !bulkFile.type.includes('csv')) {
            toast.error("Only CSV files are allowed");
            return;
        }

        const formData = new FormData();
        formData.append('file', bulkFile);

        setUploading(true);
        try {
            const sellerId = authState?._id; // Get seller ID from auth
            const response: any = await henceforthApi.Product.addBulkProduct(sellerId, formData);
            toast.success(response.data.message || "Bulk upload successful");
            // Refresh product list
            productListing();
            // Close modal and reset
            setBulkModal(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error: any) {
            handleError(error, '', authDispatch);
        } finally {
            setUploading(false);
        }
    };

    return (
        <Fragment>
            {/* breadcrum  */}
            <BreadCrumb pathNameDeclare={breadCrumbPath} />
            {/* Page  */}
            <div className='page-spacing'>
                <section className='products'>
                    <div className='product-detail-box'>
                        <AllFilter />
                        <div className="common-card">
                            <div className="common-card-title d-flex justify-content-between align-items-center gap-2 flex-column flex-sm-row">
                                <h5>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_listing} {language_data?.[authState.lang]?.common_deatil}</h5>
                                {/* {authState?.role !== 'store' && <div className="d-flex gap-2">

                                    <button
                                        className="btn btn-white btn-sm"
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = `${process.env.PUBLIC_URL}/assets/csv/Product.csv`;
                                            link.download = 'Product.csv';
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                    >
                                        <i className="fa fa-download me-1"></i>Download Sample
                                    </button> */}


                                {/* <Link className="btn btn-white btn-sm" to={authState?.is_admin_verified === 'pending' || authState?.is_admin_verified === 'reject' ? "#" : "/product/add"} onClick={(e) => {
                                        if (authState?.is_admin_verified === 'pending') {
                                            e.preventDefault();
                                            toast.error("Your account is pending for admin verification.");
                                        }
                                        if (authState?.is_admin_verified === 'reject') {
                                            e.preventDefault();
                                            toast.error("Your account is rejected for admin verification.");
                                        }
                                    }}> <i className="fa fa-plus me-1"></i>{language_data?.[authState.lang]?.common_add}</Link> */}

                                {/* NEW BULK UPLOAD BUTTON */}
                                {/* <button
                                        className="btn btn-white btn-sm"
                                        onClick={() => {
                                            if (authState?.is_admin_verified === 'pending') {
                                                toast.error("Your account is pending for admin verification.");
                                                return;
                                            }
                                            if (authState?.is_admin_verified === 'reject') {
                                                toast.error("Your account is rejected for admin verification.");
                                                return;
                                            }
                                            setBulkModal(true);
                                        }}
                                    >
                                        <i className="fa fa-upload me-1"></i>
                                        Bulk Upload
                                    </button> */}
                                {/* </div> */}
                                {/* } */}
                            </div>
                            <div className="common-card-content">
                                {/* table */}
                                <div className='data-list-table table-responsive mb-3 text-center'>
                                    {loading ? <Spinner color={"text-success"} />
                                        :
                                        <table className="table table-striped align-middle text-center">
                                            <thead className=''>
                                                <tr>
                                                    <th>{language_data?.[authState.lang]?.common_sr_no}</th>
                                                    <th>{language_data?.[authState.lang]?.common_product}{language_data?.[authState.lang]?.common_id} </th>
                                                    <th>{language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._1}</th>
                                                    <th>{language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._2}</th>
                                                    <th>{language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._3}</th>
                                                    <th>{language_data?.[authState.lang]?.common_brand}<SortIcon field='brand_name' /></th>
                                                    <th>{language_data?.[authState.lang]?.common_store || "Store_Name"}</th>
                                                    <th>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_name}<SortIcon field='name' /></th>
                                                    <th>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_price}</th>
                                                    <th>{language_data?.[authState.lang]?.common_quantity}<SortIcon field='quantity' /></th>
                                                    <th>{language_data?.[authState.lang]?.common_action}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {Array.isArray(productList.listing) && productList.listing.length ? productList.listing.map((res: any, index: number) => {
                                                    const targetStoreId = storeId || (typeof res?.store_id === 'object' ? res?.store_id?._id : res?.store_id);
                                                    return (
                                                    <tr key={res?._id}>
                                                        <td> {page === "0"
                                                            ? index + 1
                                                            : (Number(page) - 1) * Limit + (index + 1)}</td>
                                                        <td>{res?.prodct_id ? res?.prodct_id : `${language_data?.[authState.lang]?.common_not_available}`} <img src={COPY} style={{ width: 15 }} onClick={() => copyText(res.prodct_id)} role="button" data-toggle="tooltip" title={`${res.prodct_id}`} /></td>
                                                        <td>{res?.category_id ? res?.category_id?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.subcategory_id
                                                            ? res?.subcategory_id
                                                                ?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.sub_subcategory_id ? res?.sub_subcategory_id?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.brand_id ? res?.brand_id?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.store_name ? res?.store_name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td className='product-image-table'>
                                                            <SignedImage
                                                                className='me-2'
                                                                src={Array.isArray(res?.images) && res?.images?.length ? res?.images[0] : ''}
                                                                alt={res.images?.[0] || 'Product'}
                                                                fallback={laptop}
                                                                size="small"
                                                            />
                                                            {res?.name ? res?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td><b>{CURRENCY_SYMBOL}</b> {res?.price ? numberWithCommas(res?.price) : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.quantity !== 0 ? res?.quantity : `${language_data?.[authState.lang]?.common_out_of_stock}`}</td>
                                                        <td>
                                                            <div className="btn-group gap-2">
                                                                <Link className="btn btn-white btn-sm" to={authState?.is_admin_verified === 'pending' || authState?.is_admin_verified === 'reject' ? '#' : `/product/${res?._id}${targetStoreId ? `?store_id=${targetStoreId}` : ''}`} onClick={(e) => {
                                                                    if (authState?.is_admin_verified === 'pending') {
                                                                        e.preventDefault();
                                                                        toast.error("Your account is pending for admin verification.");
                                                                    }
                                                                    if (authState?.is_admin_verified === 'reject') {
                                                                        e.preventDefault();
                                                                        toast.error("Your account is rejected for admin verification.");
                                                                    }
                                                                }}> <i className="fa fa-eye me-1"></i>{language_data?.[authState.lang]?.common_view}</Link>

                                                                {authState?.role !== 'store' && <Link
                                                                    className="btn btn-white btn-sm"
                                                                    to={
                                                                        authState?.is_admin_verified === 'pending' ||
                                                                            authState?.is_admin_verified === 'reject'
                                                                            ? '#'
                                                                            : `/product/${res?._id}/edit${targetStoreId ? `?store_id=${targetStoreId}` : ''}`
                                                                    }
                                                                    onClick={(e) => {
                                                                        if (authState?.is_admin_verified === 'pending') {
                                                                            e.preventDefault();
                                                                            toast.error("Your account is pending for admin verification.");
                                                                        }
                                                                        if (authState?.is_admin_verified === 'reject') {
                                                                            e.preventDefault();
                                                                            toast.error("Your account is rejected for admin verification.");
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fa fa-pencil me-1"></i>
                                                                    {language_data?.[authState.lang]?.common_edit}
                                                                </Link>}
                                                                {/* <Link
                                                                    className="btn btn-white btn-sm"
                                                                    to="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleManageStock(res);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-cubes me-1"></i>
                                                                    Manage Stock
                                                                </Link> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    );
                                                })
                                                    : <tr className='text-center'><td colSpan={9}>{language_data?.[authState.lang]?.common_no_data_found}</td></tr>}



                                            </tbody>
                                        </table>}
                                </div>
                                {/* pagination  */}
                                <div className='dashboad-pagination-box'>
                                    <PaginationLayout
                                        data={productList.listing}
                                        count={productList.totalCount}
                                        limit={Number(Limit)}
                                        page={Number(page)}
                                    />
                                </div>
                            </div>

                            {/* Stock Modal (unchanged) */}
                            {stockModal && (
                                <div
                                    className="modal fade show"
                                    style={{
                                        display: 'block',
                                        backgroundColor: 'rgba(0,0,0,0.5)'
                                    }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">

                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    Manage Stock
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setStockModal(false)}
                                                />
                                            </div>

                                            <div className="modal-body">

                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Quantity
                                                    </label>

                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={quantity}
                                                        onChange={(e) =>
                                                            setQuantity(e.target.value)
                                                        }
                                                        min={0}
                                                        placeholder="Enter Quantity"
                                                    />
                                                </div>

                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => setStockModal(false)}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="btn btn-theme"
                                                    onClick={submitStock}
                                                >
                                                    Update Stock
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ---------- NEW BULK UPLOAD MODAL ---------- */}
                            {bulkModal && (
                                <div
                                    className="modal fade show"
                                    style={{
                                        display: 'block',
                                        backgroundColor: 'rgba(0,0,0,0.5)'
                                    }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">

                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    Bulk Upload Products
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => {
                                                        setBulkModal(false);
                                                        setBulkFile(null);
                                                        if (fileInputRef.current) fileInputRef.current.value = '';
                                                    }}
                                                />
                                            </div>

                                            <div className="modal-body">

                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Select CSV File
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept=".csv"
                                                        onChange={handleFileChange}
                                                        ref={fileInputRef}
                                                    />
                                                    <small className="text-muted">
                                                        Only CSV files are allowed. The file must contain required columns.
                                                    </small>
                                                </div>

                                                {bulkFile && (
                                                    <div className="alert alert-info">
                                                        <i className="fa fa-file-text-o me-2"></i>
                                                        {bulkFile.name} ({(bulkFile.size / 1024).toFixed(2)} KB)
                                                    </div>
                                                )}

                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => {
                                                        setBulkModal(false);
                                                        setBulkFile(null);
                                                        if (fileInputRef.current) fileInputRef.current.value = '';
                                                    }}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="btn btn-theme"
                                                    onClick={handleBulkUpload}
                                                    disabled={uploading || !bulkFile}
                                                >
                                                    {uploading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" />
                                                            Uploading...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-upload me-1" />
                                                            Upload
                                                        </>
                                                    )}
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
            <DownloadFileModal exportData={useMemo(() => exportData, [])} />
        </Fragment>
    )
}
export default StoreProducts;